import { z } from 'zod';
export const CLOSED_ACCESS_KEY_MAX_LENGTH = 256;
/**
 * Контракт описывается один раз: схема Zod здесь, тип выводится через z.infer.
 * Сервер валидирует этой схемой, клиент импортирует тип — рассинхрон невозможен.
 */
/** Сырая строка initData от Telegram. Недоверенная, пока не проверен HMAC. */
export const AuthRequestSchema = z.object({
    initData: z.string().min(1).max(4096),
    accessKey: z.string().max(CLOSED_ACCESS_KEY_MAX_LENGTH).optional(),
});
/** Игрок, подтверждённый подписью Telegram. */
export const TelegramUserSchema = z.object({
    id: z.number().int().positive(),
    firstName: z.string(),
    lastName: z.string().optional(),
    username: z.string().optional(),
    languageCode: z.string().optional(),
    isPremium: z.boolean().optional(),
});
export const AuthResponseSchema = z.object({
    accessToken: z.string(),
    refreshToken: z.string(),
    user: TelegramUserSchema,
});
/** Полезная нагрузка access-токена. */
export const AccessTokenPayloadSchema = z.object({
    sub: z.string(),
    telegramId: z.number().int().positive(),
    type: z.literal('access'),
    /** Версия допуска, подписанная серверным секретом; не сам ключ доступа. */
    closedAccess: z.string().optional(),
});
export const HealthResponseSchema = z.object({
    status: z.literal('ok'),
    version: z.string(),
    uptimeSeconds: z.number().nonnegative(),
});
/** Формат ответа при ошибке. Клиент ветвится по `code`. */
export const ErrorResponseSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        details: z.record(z.string(), z.unknown()).optional(),
    }),
});
//# sourceMappingURL=auth.js.map